export default __webpack_public_path__ + "static/media/fourth.2689e4b8.jpg";